import styles from './WheelPackage.module.scss'
import Button from '@/components/buttons/Button/Button'
import WheelSearchQueryParams from '@/types/WheelSearchQueryParams'
import { CartRowModel, ProductType } from '@/types/api'
import { buildQueryString } from '@/utils/helpers'
import { useRouter } from 'next/router'
import React from 'react'
import { useTranslation } from 'next-i18next'

type Props = {
  item: CartRowModel
}

const WheelPackage = ({ item }: Props) => {
  const { t } = useTranslation(['cart'])
  const router = useRouter()

  const editWheelPackage = () => {
    if (item.packageId === undefined) return

    const queryProperties = Object.fromEntries(new URLSearchParams(item.savedFilterQuery))

    let query: WheelSearchQueryParams = {
      pid: item.packageId.toString(),
      ktype: item.kType?.toString(),
      licenseplate: item.licensePlate,
      ...queryProperties
    }


    if (item.productType === ProductType.Tyre) {
      query.rims = item.packageRims.join('-')
    }

    const queryString = buildQueryString(query)

    router.push({
      pathname: '/wheels',
      query: queryString
    })
  }

  if (!item.packageId)
    return null

  return (
    <div className={styles.component}>
      <Button
        label={t('cart:changePackageArticle')}
        onClick={editWheelPackage}
      />
    </div>
  )
}

export default WheelPackage